export default __webpack_public_path__ + "static/media/fb.94ebad07.svg";